import {gql} from "@apollo/client";
import {PickupAppointmentFormData} from "../../types/PickupAppointmentType";

export const GET_PICKUP_APPOINTMENT_DETAIL = gql`
    query GetPickupAppointmentDetail($id: Long!) {
        getPickupAppointmentDetail(id: $id) {
            id
            warehouseId
            channelId
            cooperationWarehouseId
            cooperationWarehouseName
            appointmentNumber
            contactName
            contactPhone
            countryCode
            contactEmail
            ext
            addressLine1
            addressLine2
            country
            state
            city
            zipcode
            timezone
            workWeekdaysJson
            workStartTime
            workEndTime
            expectedPickupDate
            expectedPickupTimeStart
            expectedPickupTimeEnd
            actualPickupDate
            actualPickupTimeStart
            actualPickupTimeEnd
            expectedParcelCount
            actualParcelCount
            expectedParcelUnit
            actualParcelUnit
            vehicleTypeId
            notes
            trackingNumbersJson
            scanTrackingNumbers
            pickupSerialNosJson
            status
            source
            manualReason
            isFinished
            isAbnormal
            exceptionReasonCode
            photosS3KeysJson
            photosS3UrlJson
            exceptionPhotosS3KeysJson
            exceptionPhotosS3UrlJson
            cancelVoucherS3KeysJson
            cancelVoucherS3UrlJson
            cancelType
            cancelReason
            bolUrl
            createdAt
            updatedAt
        }
    }
`;

export interface PickupAppointmentDetailResponse {
    getPickupAppointmentDetail: PickupAppointmentFormData;
} 